export const manifest = {
  screens: {
    scr_61er0w: { name: "EOI — General Information", route: "/procurement/supplier-registration", state: {"currentStep":1}, position: {"x":160,"y":220} },
    scr_vbpop3: { name: "EOI — Business Information", route: "/procurement/supplier-registration", state: {"currentStep":2}, position: {"x":1560,"y":220} },
    scr_e8358t: { name: "EOI — Financial & Banking", route: "/procurement/supplier-registration", state: {"currentStep":3}, position: {"x":2960,"y":220} },
    scr_d5x1in: { name: "EOI — Compliance & Security", route: "/procurement/supplier-registration", state: {"currentStep":4}, position: {"x":4360,"y":220} },
    scr_qtz7z5: { name: "EOI — Declaration & Submit", route: "/procurement/supplier-registration", state: {"currentStep":5}, position: {"x":5760,"y":220} },
  },
  sections: {
    sec_3j3roo: { name: "EOI Supplier Registration", x: 0, y: 0, width: 7120, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_3j3roo", children: [
      { kind: "screen", id: "scr_61er0w" },
      { kind: "screen", id: "scr_vbpop3" },
      { kind: "screen", id: "scr_e8358t" },
      { kind: "screen", id: "scr_d5x1in" },
      { kind: "screen", id: "scr_qtz7z5" },
    ] },
  ],
}
